export default __webpack_public_path__ + "static/media/tr.e91a2e00.svg";